import React, { createContext, useState, useEffect, ReactNode } from "react";
import axios from "../axios-config";
import { ChatRoom, ChatUser } from "../types/chat";

interface ChatContextProps {
  chatRooms: ChatRoom[];
  setChatRooms: React.Dispatch<React.SetStateAction<ChatRoom[]>>;
  recipients: ChatUser[];
  setRecipients: React.Dispatch<React.SetStateAction<ChatUser[]>>;
  messages: any[];
  sendMessage: (message: string) => void;
}

// Provide default values to avoid undefined usage.
export const ChatContext = createContext<ChatContextProps>({
  chatRooms: [],
  setChatRooms: () => {},
  recipients: [],
  setRecipients: () => {},
  messages: [],
  sendMessage: () => {}
});

export function ChatProvider({ children }: { children: ReactNode }) {
  const [chatRooms, setChatRooms] = useState<ChatRoom[]>([]);
  const [recipients, setRecipients] = useState<ChatUser[]>([]);
  const [messages, setMessages] = useState<any[]>([]);

  useEffect(() => {
    // ...existing code for recipients...
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/api/ChatMessages/Recipients");
        // Merge group and individual records into unified chatRooms
        setChatRooms([
          ...(res.data.chatRooms || []),
          ...(res.data.chatUsers || [])
        ]);
        // Optionally keep chatUsers in recipients if needed elsewhere
        setRecipients(res.data.chatUsers || []);
      } catch (error) {
        console.error("Error fetching chat rooms:", error);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get('/api/ChatMessages');
        setMessages(response.data);
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    };

    fetchMessages();
  }, []);

  const sendMessage = async (message: string) => {
    try {
      const response = await axios.post('/api/ChatMessages', { chatText: message });
      setMessages((prev) => [...prev, response.data]);
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  return (
    <ChatContext.Provider value={{ chatRooms, setChatRooms, recipients, setRecipients, messages, sendMessage }}>
      {children}
    </ChatContext.Provider>
  );
}
